import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useDirectorInformation = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [directorData, setDirectorData] = useState<Record<string, any> | null>(null);

    const onDirectorInfoError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while fetching director information.',
        );
    };

    const onDirectorInfoSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        setDirectorData(data);
    };

    const directorInfo = (id: any) => {
        const url: HttpConfig = {
            url: `ba/v1/company/${id}/kyc/director-info`,
            method: 'get',
        };

        request(url, onDirectorInfoSuccess, setLoading, onDirectorInfoError);
    };

    return { directorInfo, loading, directorData };
};

export default useDirectorInformation;
